import { render, staticRenderFns } from "./ListaVarejo.vue?vue&type=template&id=62b43ee2&scoped=true&"
import script from "./ListaVarejo.vue?vue&type=script&lang=js&"
export * from "./ListaVarejo.vue?vue&type=script&lang=js&"
import style0 from "./ListaVarejo.vue?vue&type=style&index=0&id=62b43ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b43ee2",
  null
  
)

export default component.exports